<template>
    <div>
        <breadcrumb-show :title="opportunity.title"></breadcrumb-show>
        <div class="bg-gray-900 text-white md:px-6 px-4 py-6 rounded-xl shadow-md border border-gray-700 hover:border-gray-500 transition duration-300">
        <!-- Banner -->
        
            <div class="relative h-64 md:h-96 rounded-b-3xl overflow-hidden mb-10">
                <img
                    :src="opportunity.banner ?? 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?fit=crop&w=1500&q=80'"
                    alt="Banner"
                    class="object-cover w-full h-full"
                />
                <!-- Gloss Effect -->
                <div class="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-white/10 pointer-events-none"></div>
            
                <div class="absolute inset-0 bg-black/50 flex items-center justify-center">
                    <h1 class="text-3xl md:text-5xl font-bold">{{ opportunity.title }}</h1>
                </div>
            </div>

    
        <section class="max-w-6xl mx-auto px-2 space-y-8">
            <!-- Organization Name -->
            <p class="text-center text-gray-400 text-lg">{{ opportunity.organization }}</p>
    
            <!-- Meta Information -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="bg-gray-800 p-4 rounded-xl text-center">
                <h4 class="text-gray-400 text-sm mb-1">Location</h4>
                <p class="font-semibold">{{ opportunity.location }}</p>
            </div>
            <div class="bg-gray-800 p-4 rounded-xl text-center">
                <h4 class="text-gray-400 text-sm mb-1">Mode</h4>
                <p class="font-semibold">{{ opportunity.mode }}</p>
            </div>
            <div class="bg-gray-800 p-4 rounded-xl text-center">
                <h4 class="text-gray-400 text-sm mb-1">Deadline</h4>
                <p class="font-semibold">{{ opportunity.deadline }}</p>
            </div>
            </div>
    
            <!-- Description -->
            <div class="bg-gray-800 p-6 rounded-2xl leading-relaxed whitespace-pre-line">
                <!-- Description Content -->
                <p
                v-if="!isExpanded"
                class="line-clamp-7"
                >
                {{ opportunity.description }}
                </p>

                <p v-else>
                {{ opportunity.description }}
                </p>

                <!-- Toggle Read More / Show Less -->
                <button 
                @click="toggleDescription"
                class="text-blue-400 mt-2 hover:underline"
                >
                {{ isExpanded ? 'Show Less' : 'Read More' }}
                </button>
            </div>
    
            <!-- Tags -->
            <div class="flex flex-wrap gap-3" v-if="opportunity.tags">
                <span class="bg-blue-600/30 text-blue-400 px-3 py-1 rounded-full text-sm" v-if="opportunity.category">
                    {{ opportunity.category.category.name }}
                </span>
                <span
                    v-for="(tag, i) in opportunity.tags"
                    :key="i"
                    class="bg-blue-600/30 text-blue-400 px-3 py-1 rounded-full text-sm"
                >
                    {{ tag.name }}
                </span>
            </div>
    
            <!-- Action Buttons -->
            <div class="flex flex-col md:flex-row items-center justify-between gap-4 mt-8">
            <router-link :to="{ name: 'OpportunityIndex' }" class="text-gray-400 hover:underline text-sm">
                ← Back to Opportunities
            </router-link>
    
            <a :href="opportunity.link" target="_blank">
                <primary-button class="text-sm">
                Apply Now
                </primary-button>
            </a>
            </div>
        </section>
        </div>
    </div>
  </template>
  
<script setup>
    import PrimaryButton from '../button/PrimaryButton.vue'
    import BreadcrumbShow from '../breadcrumb/BreadcrumbShow.vue'
    import { useRoute, useRouter } from 'vue-router'
    import { ref, onMounted } from 'vue'
    import api from '@/utils/api'

    const route = useRoute()
    const router = useRouter()

    const opportunity = ref({})

    const isExpanded = ref(false);

    const toggleDescription = () => {
        isExpanded.value = !isExpanded.value;
    };

    onMounted(async() => {
        try {
            const response = await api.get('opportunities/show', {
                params: {
                    id: route.params.id
                }
            })

            console.log(response.data)

            if (response.data.status == 'error')
            {
                router.push({
                    path: '/'
                })
                console.log(response.data)
            }


            if (response.status == 200)
            {
                opportunity.value = response.data.data
                return
            }

            router.push({
                name: 'OpportunityIndex',
                query: {
                    message: 'Opportunity not found',
                    type: 'danger'
                }
            })
        } catch (error) {
            console.error('API error:', error)
            router.push({
                name: 'OpportunityIndex',
                query: {
                    message: 'Opportunity not found!',
                    type: 'danger'
                }
            })
        } finally {
            document.title = (opportunity.value.title || 'Opportunity') + ' | OPPI'
        }
    })
</script>

<style scoped>
    .line-clamp-7 {
        display: -webkit-box;
        -webkit-line-clamp: 7;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
</style>
  